import {withRouter, RouteComponentProps} from "react-router-dom";
import {connect} from "react-redux";
import React, {Component} from "react";
import {TransitionGroup, CSSTransition} from "react-transition-group";
import {Formik} from "formik";
import {cloneDeep} from "lodash";

import "./PresetConfiguration.component.scss";

import {Components} from "@webtech/webtech-ui-react/build/webtech-ui";
import {getNewGeneratedName} from "../../../../utils/utils";
import {SubsidiaryUtils} from "../../../../utils/Subsidiary/SubsidiaryUtils";
import {ActionCreator} from "../../../../actions/actions";
import {presetsStoreSelectors} from "../../store/store";
import {PresetsActionCreators} from "../../actions/actionCreators";

import {Dialog} from "../../../../utils/Dialog/Dialog.component";
import Form from "../../../../utils/forms/components/Form";
import FormSet from "../../../../utils/forms/components/FormSet";
import {Subsidiary} from "../../../../types/types";
import _ from "lodash";

import {
    baseConfigInitialFields,
    settingsConfigFields,
    settingsConfigFieldsNoCoin,
    easylinkSettingsConfigFields,
    easylinkSettingsConfigFieldsNoCoin,
    levelSettingsConfigFields,
    sapSettingsConfigFields,
    sapSettingsConfigFieldsNoCoin,
    MultipotsSettingsConfigFields,
    MultipotsSettingsConfigFieldsWithFrac,
    FracSettingsConfigFields,
    ReelStrikeSettingsConfigFields,
    JumboLinkSettingsConfigFields,
    JumboLinkSettingsConfigFieldsNoCoin,
    gamesSubForm,
    LuckyTokensLinkConfigFieldsNoCoin
} from "./Schemas/PresetSchemas";
import {PrizeFieldsForm, prizeFieldsValidation} from "./Schemas/PrizeFields";
import {EffectStripped} from "../../../../utils/forms/components/EffectStripped";
import getSelectableCoins from "../../../configurations/components/Utils/GetSelectableCoins/get-selectable-coins";
import {Denominations} from "../../reducers/denominations.reducer";
import FormSelect from "../../../../utils/forms/components/FormSelect";

export interface PresetConfigurationProps extends RouteComponentProps {
    getSubsidiaries: ActionCreator;
    subsidiariesLoading: boolean;
    subsidiariesList: Subsidiary[];
    updateEditingPreset: ActionCreator;
    getPreset: ActionCreator;
    clearPreset: ActionCreator;
    addPreset: ActionCreator;
    editPreset: ActionCreator;
    getDenominations: ActionCreator;
    editingPreset: any;
    submittingPresetState: any;
    submitPresetLoading: boolean;
    presetLoading: boolean;
    initialPresetPrizes: any;
    initialGameSpecificSettings: any;
    initialPreset: any;
    denominations: Denominations[];
    denominationsLoading: boolean;
    clearSubmitPreset: ActionCreator;
    getGameBundles: ActionCreator;
    getGames: ActionCreator;
    gameBundles: any[];
    gameBundlesLoading: boolean;
    gamesList: any[];
    gamesLoading: boolean;
}

export interface PresetConfigurationState {
    visible: boolean;
    cancelDialog: boolean;
    baseFormCurrentValues: {};
    settingsFormCurrentValues: {};
    prizesFormIsValid: boolean;
    prizeFormCurrentValues: {};
    gameSpecificSettingsCurrentValues: [];
    isGameSpecificSettingsFormValid: boolean;
}

const baseConfigInitialValues = {
    name: "",
    subsidiary: "",
    stype: "",
    type: "",
    notes: "",
    default: false
};

const settingsConfigInitialValues = {
    base_extra_ball_value: 0,
    progressive_redraw_time: 0,
    deduction_percent: 0,
    frequency_prize0: 0,
    frequency_prize1: 0,
    frequency_prize2: 0,
    frequency_prize3: 0,
    frequency_prize4: 0,
    min_machine_coin_in: 0,
    min_room_games_started: 0,
    prize_range: 0,
    proportion_type: "proportional",
    player_coinin_weight: 0,
    terminal_progressive_rtp_weight: 0,
    terminal_rtp_weight: 0,
    prize_value_distribution: [],
    reserve_value_distribution: [],
    rtp: ""
};

const easylinkSettingsConfigInitialValues = {
    base_extra_ball_value: 0,
    progressive_redraw_time: 0,
    deduction_percent: 0,
    frequency_prize0: 0,
    frequency_prize1: 0,
    frequency_prize2: 0,
    frequency_prize3: 0,
    frequency_prize4: 0,
    min_machine_coin_in: 0,
    min_room_games_started: 0,
    prize_range: 0,
    proportion_type: "proportional",
    player_coinin_weight: 0,
    terminal_progressive_rtp_weight: 0,
    terminal_rtp_weight: 0,
    prize_value_distribution: [],
    reserve_value_distribution: [],
    rtp: "",
    min_game_mode0: 0,
    min_game_mode1: 0,
    min_game_mode2: 0,
    min_game_mode3: 0,
    min_game_mode4: 0,

    buytype_frequency_prize0: 0,
    buytype_frequency_prize1: 0,
    buytype_frequency_prize2: 0,
    buytype_frequency_prize3: 0,
    buytype_frequency_prize4: 0,
    buytype_prize_range: 0,
    buytype_settings: {}
};

const gamesConfigInitialValues = (gameConfig) => {
    return {
        name: getNewGeneratedName("Progressive Setting", gameConfig),
        game_instances: [],
        base_extra_ball_value: 0,
        progressive_redraw_time: 0,
        deduction_percent: 0,
        frequency_prize0: 0,
        frequency_prize1: 0,
        frequency_prize2: 0,
        frequency_prize3: 0,
        frequency_prize4: 0,
        min_machine_coin_in: 0,
        min_room_games_started: 0,
        prize_range: 0,
        proportion_type: "proportional",
        player_coinin_weight: 0,
        terminal_progressive_rtp_weight: 0,
        terminal_rtp_weight: 0,
        prize_value_distribution: [],
        reserve_value_distribution: [],
        rtp: "",
        coin: [],
        min_game_mode0: 0,
        min_game_mode1: 0,
        min_game_mode2: 0,
        min_game_mode3: 0,
        min_game_mode4: 0,

        buytype_frequency_prize0: 0,
        buytype_frequency_prize1: 0,
        buytype_frequency_prize2: 0,
        buytype_frequency_prize3: 0,
        buytype_frequency_prize4: 0,
        buytype_prize_range: 0,
        buytype_settings: {}
    }
};

const sapSettingsConfigInitialValues = {
    base_extra_ball_value: 0,
    progressive_redraw_time: 15,
    deduction_percent: 0,
    frequency_prize0: 0,
    frequency_prize1: 0,
    frequency_prize2: 0,
    frequency_prize3: 0,
    frequency_prize4: 0,
    min_machine_coin_in: 0,
    min_room_games_started: 0,
    prize_range: 0,
    proportion_type: "proportional",
    player_coinin_weight: 0,
    terminal_progressive_rtp_weight: 0,
    terminal_rtp_weight: 0,
    prize_value_distribution: [],
    reserve_value_distribution: [],
    rtp: ""
};

const multipotsSettingsConfigInitialValues = {
    base_extra_ball_value: 0,
    progressive_redraw_time: 0,
    deduction_percent: 0,
    frequency_prize0: 0,
    frequency_prize1: 0,
    frequency_prize2: 0,
    frequency_prize3: 0,
    frequency_prize4: 0,
    min_machine_coin_in: 0,
    min_room_games_started: 0,
    prize_range: 0,
    proportion_type: "fractionated",
    player_coinin_weight: 0,
    terminal_progressive_rtp_weight: 0,
    terminal_rtp_weight: 0,
    prize_value_distribution: [],
    reserve_value_distribution: [],
    rtp: ""
};

const fracSettingsConfigInitialValues = {
    initial_value: 100000,
    max_value: 900000,
    contribution: 0.5,
    proportion_type: "fractionated",
    fractionated_jackpot_list: []
};

const reelStrikeSettingsConfigInitialValues = {
    coin: [],
    prize_range: 0,
    proportion_type: "normal",
    frequency_prize0: 0,
    frequency_prize1: 0,
    frequency_prize2: 0,
    frequency_prize3: 0,
    frequency_prize4: 0,
    deduction_percent: 0,
    min_machine_coin_in: 0,
    terminal_rtp_weight: 0,
    player_coinin_weight: 0,
    base_extra_ball_value: 0,
    min_room_games_started: 0,
    progressive_redraw_time: 0,
    prize_value_distribution: [],
    reserve_value_distribution: [],
    terminal_progressive_rtp_weight: 0,
    frequency_prizes_list0: [],
    frequency_prizes_list1: [],
    frequency_prizes_list2: [],
    frequency_prizes_list3: [],
    frequency_prizes_list4: [],
    min_machine_coin_in0: 0,
    min_machine_coin_in1: 0,
    min_machine_coin_in2: 0,
    min_machine_coin_in3: 0,
    min_machine_coin_in4: 0,
    rtp: ""
};

const jumboLinkSettingsConfigInitialValues = {
    coin: [],
    base_extra_ball_value: 0,
    progressive_redraw_time: 0,
    deduction_percent: 0,
    frequency_prize0: 0,
    frequency_prize1: 0,
    frequency_prize2: 0,
    frequency_prize3: 0,
    frequency_prize4: 0,
    min_machine_coin_in: 0,
    min_room_games_started: 0,
    prize_range: 0,
    proportion_type: "proportional",
    player_coinin_weight: 0,
    terminal_progressive_rtp_weight: 0,
    terminal_rtp_weight: 0,
    prize_value_distribution: [],
    reserve_value_distribution: [],
    rtp: ""
};
const levelSettingsConfigInitialValues = {
    coin: [],
    proportion_type: "normal",
    rtp: ""
};

export const LEVELS_NAMES = {
    0: "Mega",
    1: "Grand",
    2: "Major",
    3: "Minor",
    4: "Mini"
};

class PresetConfiguration extends Component<
    PresetConfigurationProps,
    PresetConfigurationState
> {
    baseForm: React.RefObject<Form>;
    settingsForm: React.RefObject<Form>;
    gameSpecificSettingsForm: React.RefObject<FormSet>;
    isDetail: boolean;
    isEdit: boolean;
    isNotes: boolean;
    hasRedirected: boolean;

    constructor(props) {
        super(props);

        this.props.clearPreset();
        this.props.getDenominations();

        if (
            this.props.subsidiariesList.length == 0 &&
            !this.props.subsidiariesLoading
        ) {
            this.props.getSubsidiaries();
        }

        if (
            this.props.gamesList.length == 0 &&
            !this.props.gamesLoading
        ) {
            this.props.getGames();
        }

        if (
            this.props.gameBundles.length == 0 &&
            !this.props.gameBundlesLoading
        ) {
            this.props.getGameBundles();
        }

        this.baseForm = React.createRef();
        this.settingsForm = React.createRef();
        this.gameSpecificSettingsForm = React.createRef();

        this.isDetail = this.props.match.path.includes("/detail");
        this.isEdit = this.props.match.path.includes("/edit");
        this.isNotes = this.props.match.path.includes("/notes");

        if (this.isDetail || this.isEdit || this.isNotes) {
            if (!this.props.match.params["presetId"]) {
                this.cancelConfig()
            } else {
                this.props.getPreset(this.props.match.params["presetId"]);
            }
        }

        this.state = {
            visible: false,
            cancelDialog: false,
            baseFormCurrentValues: baseConfigInitialValues,
            settingsFormCurrentValues: settingsConfigInitialValues,
            prizesFormIsValid: false,
            prizeFormCurrentValues: {},
            gameSpecificSettingsCurrentValues: [],
            isGameSpecificSettingsFormValid: false
        };
    }

    componentDidMount() {
        if (
            this.props.subsidiariesList.length == 0 &&
            !this.props.subsidiariesLoading
        ) {
            this.props.getSubsidiaries();
        }

        if (
            this.props.gamesList.length == 0 &&
            !this.props.gamesLoading
        ) {
            this.props.getGames();
        }

        if (
            this.props.gameBundles.length == 0 &&
            !this.props.gameBundlesLoading
        ) {
            this.props.getGameBundles();
        }

        this.setState({
            visible: true
        });
    }

    componentWillReceiveProps(nextProps) {
        if ((this.isEdit || this.isDetail || this.isNotes) && nextProps.initialGameSpecificSettings.length > 0 &&
            _.difference(nextProps.initialGameSpecificSettings, this.props.initialGameSpecificSettings)) {
            this.setState({
                gameSpecificSettingsCurrentValues: nextProps.initialGameSpecificSettings
            });
        }
    }

    cancelConfig = () => {
        this.props.history.push(`/admin/progressives-presets`);
    };

    clickCancel = () => {
        /*if (!this.props.submittingConfigurationLoading) {
            const { params } = this.props.match;
            if (params["editingServer"] && params["editingConfig"]) {*/
        this.cancelConfig();
        /*} else {
                this.setState({
                    cancelDialog: true
                });
            }
        }*/
    };

    closeCancelDialog = () => {
        this.setState({
            cancelDialog: false
        });
    };

    onChangeBaseForm = data => {
        if (data.values.settings) {
            data.values.settings = this.state.settingsFormCurrentValues;
        }
        if (
            this.state.baseFormCurrentValues["stype"] !== "" &&
            data.values.stype == ""
        ) {
            data.values.stype = this.state.baseFormCurrentValues["stype"];
        }
        if (
            data.values.type !== this.state.baseFormCurrentValues["type"] &&
            this.state.baseFormCurrentValues["type"] !== ""
        ) {
            data.values.stype = "";
            this.setState({
                prizeFormCurrentValues: {}
            });
        }

        if (
            this.state.baseFormCurrentValues["subsidiary"] !== "" &&
            data.values.subsidiary !==
            this.state.baseFormCurrentValues["subsidiary"]
        ) {
            data.values.type = "";
            data.values.stype = "";
        }

        this.setState({
            baseFormCurrentValues: data.values
        });
        this.props.updateEditingPreset(data.values);

    };

    onChangeSettingsForm = data => {
        this.setState({settingsFormCurrentValues: data.values});
        this.props.updateEditingPreset({
            settings: data.values
        });
    };

    onChangePrizeForm = data => {
        let values = {...data.values};
        //SAP
        if (this.state.baseFormCurrentValues["type"] == 3) {
            const prizes = this.getPrizes();
            //elimina values que já n existem na seleção
            Object.keys(values).map(v => {
                let index_prize = v.substring(0, v.indexOf('_'));
                if (!prizes.includes(parseInt(index_prize))) {
                    delete values[v];
                }
            });
            prizes.map(prize => {
                if (!values.hasOwnProperty(`${prize}_individual_pot`)) {
                    values[`${prize}_individual_pot`] = false;
                }
            });
        }
        //Multipots
        if (this.state.baseFormCurrentValues["type"] == 1) {

            const prizes = this.getPrizes();
            prizes.map(prize => {
                if (!values.hasOwnProperty(`${prize}_fractionated_jackpot_list`)) {
                    values[`${prize}_fractionated_jackpot_list`] = [];
                }
                if (this.props.editingPreset.settings && this.props.editingPreset.settings.proportion_type !== 'fractionated') {
                    values[`${prize}_fractionated_jackpot_list`] = [];
                }
            });

            //elimina values que já n existem na seleção
            Object.keys(values).map(v => {
                let index_prize = v.substring(0, v.indexOf('_'));
                if (!prizes.includes(parseInt(index_prize))) {
                    delete values[v];
                }
                if (this.props.editingPreset.hasOwnProperty("settings") && this.props.editingPreset["settings"]["proportion_type"] != "proportional") {
                    if (values.hasOwnProperty(`${index_prize}_max_proportional_total_bet`)) {
                        delete values[`${index_prize}_max_proportional_total_bet`];
                    }
                }
            })
        }
        //Jumbo Link
        if (this.state.baseFormCurrentValues["type"] == 8) {
            const prizes = this.getPrizes();
            //elimina values que já n existem na seleção
            Object.keys(values).map(v => {
                let index_prize = v.substring(0, v.indexOf('_'));
                if (!prizes.includes(parseInt(index_prize))) {
                    delete values[v];
                }
                if (this.props.editingPreset.hasOwnProperty("settings") && this.props.editingPreset["settings"]["proportion_type"] != "proportional") {
                    if (values.hasOwnProperty(`${index_prize}_max_proportional_total_bet`)) {
                        delete values[`${index_prize}_max_proportional_total_bet`];
                    }
                }
            })
        }

        //EasyLink
        if (this.state.baseFormCurrentValues["type"] == 2) {
            const prizes = this.getPrizes();
            //elimina values que já n existem na seleção
            Object.keys(values).map(v => {
                let index_prize = v.substring(0, v.indexOf('_'));
                if (!prizes.includes(parseInt(index_prize))) {
                    delete values[v];
                }
            });
            prizes.map(prize => {
                if (!values.hasOwnProperty(`${prize}_individual_pot`)) {
                    values[`${prize}_individual_pot`] = false;
                }
            });
        }
        //Reel Strike
        if (this.state.baseFormCurrentValues["type"] == 7) {
            const prizes = [0, 1];
            prizes.map(prize => {
                if (!values.hasOwnProperty(`${prize}_individual_pot`)) {
                    values[`${prize}_individual_pot`] = false;
                }
            });
        }
        //LuckyToken
        if (this.state.baseFormCurrentValues["type"] == 9) {
            const prizes = this.getPrizes();
            //elimina values que já n existem na seleção
            Object.keys(values).map(v => {
                let index_prize = v.substring(0, v.indexOf('_'));
                if (!prizes.includes(parseInt(index_prize))) {
                    delete values[v];
                }
            });
            prizes.map(prize => {
                if (!values.hasOwnProperty(`${prize}_individual_pot`)) {
                    values[`${prize}_individual_pot`] = false;
                }
            });
        }
        this.setState({
            prizesFormIsValid: Object.keys(data.errors).length === 0,
            prizeFormCurrentValues: values
        });
    };

    submitPresetForm = () => {
        let baseEditingPreset = cloneDeep(this.props.editingPreset)
        let baseGameSpecificSettingsCurrentValues = cloneDeep(this.state.gameSpecificSettingsCurrentValues)

        if (this.isEdit) {
            baseEditingPreset.hasOwnProperty('id') && delete baseEditingPreset['id'];
            if (baseEditingPreset.hasOwnProperty('certified')) baseEditingPreset['certified'] = false;
        }

        if (baseEditingPreset.type === 0) baseEditingPreset.stype = null
        if (baseEditingPreset.type === 2) {
            if (baseEditingPreset.settings.hasOwnProperty('buytype_frequency_prize0')){
                if (baseEditingPreset.settings['buytype_frequency_prize0'] !== "" &&
                    baseEditingPreset.settings['buytype_frequency_prize1'] !== "" &&
                    baseEditingPreset.settings['buytype_frequency_prize2'] !== "" &&
                    baseEditingPreset.settings['buytype_frequency_prize3'] !== "" &&
                    baseEditingPreset.settings['buytype_frequency_prize4'] !== "" &&
                    baseEditingPreset.settings['buytype_prize_range'] !== ""
                ){
                    baseEditingPreset.settings['buytype_settings'] =
                    {
                        "prize_range": baseEditingPreset.settings['buytype_prize_range'],
                        "frequency_prize0": baseEditingPreset.settings['buytype_frequency_prize0'],
                        "frequency_prize1": baseEditingPreset.settings['buytype_frequency_prize1'],
                        "frequency_prize2": baseEditingPreset.settings['buytype_frequency_prize2'],
                        "frequency_prize3": baseEditingPreset.settings['buytype_frequency_prize3'],
                        "frequency_prize4": baseEditingPreset.settings['buytype_frequency_prize4']
                    }

                } else {
                    baseEditingPreset.settings['buytype_frequency_prize0'] = ""
                    baseEditingPreset.settings['buytype_frequency_prize1'] = ""
                    baseEditingPreset.settings['buytype_frequency_prize2'] = ""
                    baseEditingPreset.settings['buytype_frequency_prize3'] = ""
                    baseEditingPreset.settings['buytype_frequency_prize4'] = ""
                    baseEditingPreset.settings['buytype_prize_range'] = ""
                }
            }



            for (var i = 0; i < baseGameSpecificSettingsCurrentValues.length; i++) {
                if (baseGameSpecificSettingsCurrentValues[i].hasOwnProperty('buytype_frequency_prize0')){
                    if (baseGameSpecificSettingsCurrentValues[i]['buytype_frequency_prize0'] !== "" &&
                        baseGameSpecificSettingsCurrentValues[i]['buytype_frequency_prize1'] !== "" &&
                        baseGameSpecificSettingsCurrentValues[i]['buytype_frequency_prize2'] !== "" &&
                        baseGameSpecificSettingsCurrentValues[i]['buytype_frequency_prize3'] !== "" &&
                        baseGameSpecificSettingsCurrentValues[i]['buytype_frequency_prize4'] !== "" &&
                        baseGameSpecificSettingsCurrentValues[i]['buytype_prize_range'] !== ""
                    ){
                        baseGameSpecificSettingsCurrentValues[i]['buytype_settings'] =
                        {
                            "prize_range": baseGameSpecificSettingsCurrentValues[i]['buytype_prize_range'],
                            "frequency_prize0": baseGameSpecificSettingsCurrentValues[i]['buytype_frequency_prize0'],
                            "frequency_prize1": baseGameSpecificSettingsCurrentValues[i]['buytype_frequency_prize1'],
                            "frequency_prize2": baseGameSpecificSettingsCurrentValues[i]['buytype_frequency_prize2'],
                            "frequency_prize3": baseGameSpecificSettingsCurrentValues[i]['buytype_frequency_prize3'],
                            "frequency_prize4": baseGameSpecificSettingsCurrentValues[i]['buytype_frequency_prize4']
                        }

                    } else {
                        baseGameSpecificSettingsCurrentValues[i]['buytype_frequency_prize0'] = ""
                        baseGameSpecificSettingsCurrentValues[i]['buytype_frequency_prize1'] = ""
                        baseGameSpecificSettingsCurrentValues[i]['buytype_frequency_prize2'] = ""
                        baseGameSpecificSettingsCurrentValues[i]['buytype_frequency_prize3'] = ""
                        baseGameSpecificSettingsCurrentValues[i]['buytype_frequency_prize4'] = ""
                        baseGameSpecificSettingsCurrentValues[i]['buytype_prize_range'] = ""
                    }
                }
            }
        }

        var notes = ""
        if (baseEditingPreset.notes){
            notes = baseEditingPreset.notes
            delete baseEditingPreset.notes;
        }

        if (this.isNotes){
            this.props.editPreset({
                game_specific_settings: baseGameSpecificSettingsCurrentValues,
                prizes: this.state.prizeFormCurrentValues,
                base: baseEditingPreset,
                notes: notes,
                presetId: baseEditingPreset['id']
            });
        }else{
            this.props.addPreset({
                game_specific_settings: baseGameSpecificSettingsCurrentValues,
                prizes: this.state.prizeFormCurrentValues,
                base: baseEditingPreset,
                notes: notes
            });
        }



    };

    checkPrizesForProportionType = (proportionType, prizes) => {
        let wrongField = "max_bet";
        if (proportionType == "proportional") {
            wrongField = "min_bet";
        }
        const keys = Object.keys(prizes).filter(key =>
            key.endsWith(wrongField)
        );
        keys.map(key => {
            delete prizes[key];
        });
        return prizes;
    };

    getPrizes = () => {
        let prizes = [];
        switch (this.props.editingPreset.type) {
            case 0:
                // Levels
                prizes = [1, 2, 3, 4].reverse();
                break;
            case 1:
                // Multipots
                if (this.props.editingPreset.stype == "parent") {
                    prizes = [0];
                } else if (this.props.editingPreset.stype == "child") {
                    prizes = [1, 2, 3].reverse();
                } else {
                    prizes = [0, 1, 2, 3].reverse();
                }
                break;
            case 2:
                // EasyLink
                if (this.props.editingPreset.stype == "parent") {
                    prizes = [1];
                } else if (this.props.editingPreset.stype == "child") {
                    prizes = [2];
                } else {
                    prizes = [1, 2].reverse();
                }
                break;
            case 3:
                // SAP
                if (this.props.editingPreset.stype == "parent") {
                    prizes = [1];
                } else if (this.props.editingPreset.stype == "child") {
                    prizes = [3];
                } else {
                    prizes = [1, 3].reverse();
                }
                break;
            case 7:
                // Real Strike
                if (this.props.editingPreset.stype == "child") {
                    prizes = [0, 1, 2, 3, 4].reverse();
                }
                break;
            case 8:
                // Jumbo Link
                if (this.props.editingPreset.stype == "parent") {
                    prizes = [0];
                } else if (this.props.editingPreset.stype == "child") {
                    prizes = [1];
                }
                break;
            case 9:
                // LuckyToken
                if (this.props.editingPreset.stype == "child") {
                    prizes = [1];
                }
        }
        return prizes;
    };

    renderForm = () => {
        let prizes = this.getPrizes();

        let initialValues = this.state.prizeFormCurrentValues;

        if (
            (this.isDetail || this.isEdit || this.isNotes) &&
            this.props.editingPreset.type == this.props.initialPreset.type &&
            this.props.editingPreset.stype == this.props.initialPreset.stype
        ) {
            initialValues = this.props.initialPresetPrizes;
        }

        const currentProportion = this.props.editingPreset.settings
            ? this.props.editingPreset.settings.proportion_type
            : settingsConfigInitialValues.proportion_type;

        initialValues = this.checkPrizesForProportionType(currentProportion, {
            ...initialValues
        });

        if (this.props.editingPreset.type == 2) {
            if (this.props.editingPreset.stype == "parent" && !("1_min_game_mode" in initialValues)) {
                initialValues["1_min_game_mode"] = 0;
            } else if (this.props.editingPreset.stype == "child" && !("2_min_game_mode" in initialValues)) {
                initialValues["2_min_game_mode"] = 0;
            }
        }

        let coins = this.getSelectedSubsidiaryCoins()
        return (
            <Formik
                key={`${this.props.editingPreset.type}-${this.props.editingPreset.stype}-${currentProportion}`}
                initialValues={initialValues}
                onSubmit={values => {
                }}
                validationSchema={prizeFieldsValidation({
                    progType: this.props.editingPreset.type,
                    prizes: prizes,
                    proportion_type:
                        (this.props.editingPreset.settings &&
                            this.props.editingPreset.settings
                                .proportion_type) ||
                        "proportional",
                    prize_type: this.props.editingPreset.stype,
                    coins: coins
                })}
                render={props => {
                    return (
                        <React.Fragment>
                            <EffectStripped
                                {...props}
                                onChange={this.onChangePrizeForm}
                            />
                            {PrizeFieldsForm({
                                progType: this.props.editingPreset.type,
                                prizes: prizes,
                                proportion_type:
                                    (this.props.editingPreset.settings &&
                                        this.props.editingPreset.settings
                                            .proportion_type) ||
                                    "proportional",
                                prize_type: this.props.editingPreset.stype,
                                coins: coins
                            })}
                        </React.Fragment>
                    );
                }}
            />
        );
    };

    getSelectedSubsidiaryCoins = () => {
        const subsidiary = this.props.subsidiariesList.find(
            sub => sub.id == this.props.editingPreset.subsidiary
        );

        if (subsidiary) {
            const selectedDenominations = this.props.denominations.find(d => {
                return d.country_id == subsidiary.country.id;
            });
            return getSelectableCoins({
                denominationsList: selectedDenominations
            });
        }
        return [];
    };

    componentDidUpdate() {
        if (
            !this.hasRedirected &&
            (this.isEdit || this.isNotes) &&
            this.props.editingPreset != undefined &&
            Object.keys(this.props.editingPreset).length > 0 &&
            (this.props.editingPreset.subsidiary == undefined ||
                this.props.editingPreset.subsidiary == "")
        ) {
            this.hasRedirected = true;
            this.cancelConfig()
        }
    }

    onChangeGameSpecificSettingsForm = formEvent => {
        this.setState({
            gameSpecificSettingsCurrentValues: formEvent.values,
            isGameSpecificSettingsFormValid: formEvent.isValid
        });
    };

    render() {
        if (
            this.props.subsidiariesList.length == 0 ||
            this.props.subsidiariesLoading ||
            this.props.presetLoading ||
            this.props.denominationsLoading ||
            this.props.gameBundlesLoading ||
            this.props.gamesLoading
        ) {
            return (
                <div id="PresetConfiguration" className="visible">
                    <div className="loading" key="loading">
                        <Components.LoadingRipple width={100} height={100}/>
                    </div>
                </div>
            );
        } else if (
            (this.isDetail || this.isEdit || this.isNotes) &&
            (Object.keys(this.props.initialPresetPrizes).length === 0)
        ) {
            return (
                <div id="PresetConfiguration" className="visible">
                    <div className="sidebar-layout">
                        <div className="container header" style={{textAlign: "end"}}>
                            <button onClick={this.cancelConfig}>
                                Cancel
                            </button>
                        </div>
                    </div>
                    <div className="error-config">
                        Progressive Preset does not exist.
                    </div>
                </div>
            )
        }

        const isBaseFormValid =
            this.props.editingPreset.name !== undefined &&
            this.props.editingPreset.name !== "" &&
            this.props.editingPreset.subsidiary !== undefined &&
            this.props.editingPreset.subsidiary !== "" &&
            this.props.editingPreset.type !== undefined &&
            this.props.editingPreset.type !== "" &&
            this.props.editingPreset.stype !== undefined &&
            this.props.editingPreset.stype !== "";

        const isSettingsFormValid =
            this.settingsForm.current &&
            this.settingsForm.current.state.validation.isValidSync(
                this.state.settingsFormCurrentValues
            );

        const isGameSpecificSettingsFormValid = this.state.gameSpecificSettingsCurrentValues.length > 0 ?
            this.state.isGameSpecificSettingsFormValid : true;

        const settingsInitialValues =
            (this.isDetail || this.isEdit || this.isNotes) && this.props.editingPreset.subsidiary == this.props.initialPreset.subsidiary
                ? this.props.initialPreset.settings
                : this.props.editingPreset.type !== undefined && this.props.editingPreset.type !== "" ?
                    (this.props.editingPreset.type == 0)
                        ? levelSettingsConfigInitialValues
                        : (this.props.editingPreset.type == 2)
                            ? easylinkSettingsConfigInitialValues
                            : (this.props.editingPreset.type == 3)
                                ? sapSettingsConfigInitialValues
                                : (this.props.editingPreset.type == 1)
                                    ? multipotsSettingsConfigInitialValues
                                    : (this.props.editingPreset.type == 4)
                                        ? fracSettingsConfigInitialValues
                                        : (this.props.editingPreset.type == 7)
                                            ? reelStrikeSettingsConfigInitialValues
                                            : jumboLinkSettingsConfigInitialValues
                    : settingsConfigInitialValues;

        const enabledPrizesForm =
            this.props.editingPreset.type !== undefined &&
            this.props.editingPreset.type !== "" &&
            this.props.editingPreset.stype !== undefined &&
            this.props.editingPreset.stype !== "" &&
            this.props.editingPreset.subsidiary !== undefined &&
            this.props.editingPreset.subsidiary !== "";

        let settingsFields = undefined;
        /*
        this.props.editingPreset.type
        0 levels
        1 multipots
        2 easylink
        3 sap
        4 fractionated
        7 reelstrike
        8 jumbolink
        9 luckytoken
         */
        switch (this.props.editingPreset.type) {
            case 0:
                settingsFields = levelSettingsConfigFields({
                    coins: this.getSelectedSubsidiaryCoins()
                });
                break;
            case 1:
                if (this.props.editingPreset.stype == "child") {
                    settingsFields = MultipotsSettingsConfigFields({
                        coins: this.getSelectedSubsidiaryCoins()
                    });
                } else {
                    settingsFields = MultipotsSettingsConfigFieldsWithFrac();
                }
                break;
            case 2:
                if (this.props.editingPreset.stype == "child") {
                    settingsFields = easylinkSettingsConfigFieldsNoCoin({
                        coins: this.getSelectedSubsidiaryCoins()
                    });
                } else {
                    settingsFields = easylinkSettingsConfigFields({
                        coins: this.getSelectedSubsidiaryCoins()
                    });
                }
                break;
            case 3:
                if (this.props.editingPreset.stype == "child") {
                    settingsFields = sapSettingsConfigFieldsNoCoin({
                        coins: this.getSelectedSubsidiaryCoins()
                    });
                } else {
                    settingsFields = sapSettingsConfigFields({
                        coins: this.getSelectedSubsidiaryCoins()
                    });
                }
                break;
            case 4:
                if (this.props.editingPreset.stype == "single") {
                    settingsFields = FracSettingsConfigFields({
                        coins: this.getSelectedSubsidiaryCoins()
                    });
                }
                break;
            case 7:
                if (this.props.editingPreset.stype == "child") {
                    settingsFields = ReelStrikeSettingsConfigFields({
                        coins: this.getSelectedSubsidiaryCoins()
                    });
                }
                break;
            case 8:
                if (this.props.editingPreset.stype == "child") {
                    settingsFields = JumboLinkSettingsConfigFieldsNoCoin();
                } else {
                    settingsFields = JumboLinkSettingsConfigFields({
                        coins: this.getSelectedSubsidiaryCoins()
                    });
                }
                break;
            case 9:
                if (this.props.editingPreset.stype == "child") {
                    settingsFields = LuckyTokensLinkConfigFieldsNoCoin({
                        coins: this.getSelectedSubsidiaryCoins()
                    });
                }
                break;
            default:
                settingsFields = levelSettingsConfigFields({
                    coins: this.getSelectedSubsidiaryCoins()
                });
                break;
        }


        const fullInstanceList = this.props.gamesList ? this.props.gamesList.map(game => {
            return {
                value: game.id,
                label: game.name
            };
        }) : [];

        const fullBundlesList = this.props.gameBundles ? this.props.gameBundles
            .filter(bundle => bundle.games.length > 0)
            .map(bundle => {
                let show_alias = bundle.alias.find(a => a.subsidiary == this.props.editingPreset.subsidiary)
                return {
                    value: bundle.id,
                    label: show_alias && show_alias.value && show_alias ? show_alias.value : bundle.name,
                    games: bundle.games
                };
            }) : [];

        const selectedGameInstances = []
        this.state.gameSpecificSettingsCurrentValues.map(game => {
                const games = game['game_instances'] ? game['game_instances'] : [];
                games.map(instance => {
                    if (!selectedGameInstances.includes(instance)) selectedGameInstances.push(instance)
                })
            }
        );
        return (
            <div
                id="PresetConfiguration"
                className={this.state.visible ? "visible" : ""}
            >
                <div className="sidebar-layout">
                    <div className="config-content">
                        <div className="container header">
                            <h1>
                                {this.isDetail
                                    ? `Preset ${this.props.editingPreset.name} - Details`
                                    : this.isNotes ? `Preset ${this.props.editingPreset.name} - Edit notes`
                                        :"New Progressive Preset"}
                            </h1>
                            <button onClick={this.clickCancel}>
                                Cancel
                            </button>
                        </div>
                        <div
                            className={`container ${this.isDetail ? "readonly" : ""}`}
                        >
                            <TransitionGroup>
                                <CSSTransition
                                    key={"preset-config"}
                                    timeout={600}
                                    classNames="fade-tabs"
                                >
                                    <div className="form-content">
                                        <div className="inner-card">
                                            <div className="inner-card-title">
                                                Base
                                                <span
                                                    className={`form-validation-icon ${isBaseFormValid
                                                        ? "valid"
                                                        : "invalid"
                                                    }`}
                                                >
                                                        {!isBaseFormValid ?
                                                            <i className="icon-times-circle-solid"/> :
                                                            <i className="icon-check-circle"/>
                                                        }
                                                    </span>
                                            </div>
                                            <div className="inner-card-content">
                                                <Form
                                                    key={`${this.state.baseFormCurrentValues["subsidiary"]}-${this.state.baseFormCurrentValues["type"]}-${this.state.baseFormCurrentValues["stype"]}`}
                                                    ref={this.baseForm}
                                                    fields={baseConfigInitialFields(
                                                        {
                                                            subsidiaries:
                                                                SubsidiaryUtils.subsidiarySelectItems(
                                                                    this.props.subsidiariesList
                                                                ),
                                                            values: this.state.baseFormCurrentValues,
                                                            isDisabled: this.isEdit || this.isNotes,
                                                            isNameDisabled: this.isNotes
                                                        }
                                                    )}
                                                    initialValues={
                                                        this.isDetail ||
                                                        this.isEdit ||
                                                        this.isNotes
                                                            ? this.props.initialPreset
                                                            : this.state.baseFormCurrentValues
                                                    }
                                                    onChange={
                                                        this.onChangeBaseForm
                                                    }
                                                />
                                            </div>
                                        </div>
                                        {this.props.editingPreset.type !== "" &&
                                            this.props.editingPreset.stype !== "" && (
                                                <div className={`inner-card ${this.isNotes ? "readonly" : ""}`}>
                                                    <div className="inner-card-title">
                                                        Setting Keys
                                                        <span
                                                            className={`form-validation-icon ${isSettingsFormValid
                                                                ? "valid"
                                                                : "invalid"
                                                            }`}
                                                        >
                                                            {!isSettingsFormValid &&
                                                                this.props.editingPreset.subsidiary !== undefined &&
                                                                this.props.editingPreset.subsidiary !== "" && (
                                                                    <i className="icon-times-circle-solid"/>
                                                                )}
                                                            {isSettingsFormValid &&
                                                                this.props.editingPreset.subsidiary !== undefined &&
                                                                this.props.editingPreset.subsidiary !== "" && (
                                                                    <i className="icon-check-circle"/>
                                                                )}
                                                            </span>
                                                    </div>

                                                    <div className="inner-card-content">
                                                        {(this.props.editingPreset.subsidiary === undefined ||
                                                            this.props.editingPreset.subsidiary === "") && (
                                                            <div className="col-12">
                                                                <label className="prizes-available">
                                                                    Please select a Subsidiary before configuring
                                                                    Setting Keys.
                                                                </label>
                                                            </div>
                                                        )}

                                                        {this.props.editingPreset.type === 2 && (
                                                            <div className="col-12">
                                                                <label className="prizes-available">
                                                                    Servers with version 2.6.3 and above ignore the Prizes: Min. Game Mode field and use the values defined in the Settings Keys: Min. Game Mode 0 to Min. Game Mode 4 fields.
                                                                    Have this in mind while creating the preset.
                                                                </label>
                                                            </div>
                                                        )}

                                                        {this.props.editingPreset.subsidiary !== undefined &&
                                                            this.props.editingPreset.subsidiary !== "" && (
                                                                <Form
                                                                    key={`${this.props.editingPreset.hasOwnProperty("subsidiary")
                                                                        ? this.props.editingPreset.subsidiary + "_" + this.props.editingPreset.stype
                                                                        : "settings"
                                                                    }`}
                                                                    ref={
                                                                        this.settingsForm
                                                                    }
                                                                    fields={
                                                                        settingsFields
                                                                    }
                                                                    initialValues={
                                                                        settingsInitialValues//this.props.editingPreset.type == '' ? sapSettingsConfigFields : settingsInitialValues
                                                                    }
                                                                    onChange={
                                                                        this.onChangeSettingsForm
                                                                    }
                                                                />
                                                            )}
                                                    </div>
                                                </div>
                                            )}


                                        <div className={`inner-card ${this.isNotes ? "readonly" : ""}`}>
                                            {this.props.editingPreset.stype !== "single" && (
                                                <div
                                                    className="inner-card-title">
                                                    Prizes
                                                    <span
                                                        className={`form-validation-icon ${this.state
                                                            .prizesFormIsValid
                                                            ? "valid"
                                                            : "invalid"
                                                        }`}
                                                    >
                                                        {!this.state
                                                                .prizesFormIsValid &&
                                                            enabledPrizesForm && (
                                                                <i className="icon-times-circle-solid"/>
                                                            )}
                                                        {this.state
                                                                .prizesFormIsValid &&
                                                            enabledPrizesForm && (
                                                                <i className="icon-check-circle"/>
                                                            )}
                                                    </span>
                                                </div>)}
                                            <div className="inner-card-content">
                                                {!enabledPrizesForm ?
                                                    <div className="col-12">
                                                        <label className="prizes-available">
                                                            Please select a
                                                            Subsidiary,
                                                            Jackpot Type and
                                                            Prize Type
                                                            before
                                                            configuring
                                                            Prizes
                                                            information.
                                                        </label>
                                                    </div>
                                                    : this.renderForm()
                                                }

                                            </div>
                                        </div>
                                        {this.props.editingPreset.type !== "" &&
                                            this.props.editingPreset.stype !== "" &&
                                            (this.props.editingPreset.type === 2 || this.props.editingPreset.type === 9) && (
                                                <div className={`inner-card ${this.isNotes ? "readonly" : ""}`}>
                                                    <div className="inner-card-title">
                                                        <p>
                                                            Alternative Progressive Settings
                                                            <span>{` (${this.state.gameSpecificSettingsCurrentValues.length})`}</span>
                                                        </p>
                                                        <span
                                                            className={`form-validation-icon-games ${isGameSpecificSettingsFormValid
                                                                ? "valid"
                                                                : "invalid"
                                                            }`}
                                                        >
                                                            {!isGameSpecificSettingsFormValid &&
                                                                this.props.editingPreset.subsidiary !== undefined &&
                                                                this.props.editingPreset.subsidiary !== "" && (
                                                                    <i className="icon-times-circle-solid"/>
                                                                )}
                                                            {isGameSpecificSettingsFormValid &&
                                                                this.props.editingPreset.subsidiary !== undefined &&
                                                                this.props.editingPreset.subsidiary !== "" && (
                                                                    <i className="icon-check-circle"/>
                                                                )}
                                                            </span>
                                                        <button
                                                            className="form-validation-icon-games-add"
                                                            onClick={() => this.gameSpecificSettingsForm.current.onAdd(0)}>
                                                            <i className="icon-plus-light "/>
                                                        </button>
                                                    </div>
                                                    <div className="inner-card-content">
                                                        <FormSet
                                                            key={`${this.props.editingPreset.hasOwnProperty("subsidiary")
                                                                ? this.props.editingPreset.subsidiary + "_" + this.props.editingPreset.stype
                                                                : "games"
                                                            }`}
                                                            ref={this.gameSpecificSettingsForm}
                                                            subFormTypes={[gamesSubForm(
                                                                this.getSelectedSubsidiaryCoins(),
                                                                gamesConfigInitialValues(this.state.gameSpecificSettingsCurrentValues),
                                                                fullInstanceList,
                                                                fullBundlesList,
                                                                selectedGameInstances,
                                                                this.props.editingPreset.stype !== "child")
                                                            ]}
                                                            initialValues={this.state.gameSpecificSettingsCurrentValues}
                                                            onChange={this.onChangeGameSpecificSettingsForm}
                                                            hideAdd
                                                            isConfig={true}
                                                        />
                                                    </div>
                                                </div>
                                            )}
                                    </div>
                                </CSSTransition>
                            </TransitionGroup>
                        </div>
                        {!this.isDetail && (
                            <div className={`navigation container`}>
                                <button
                                    className={`next ${this.props.submitPresetLoading
                                        ? "loading"
                                        : ""
                                    }`}
                                    disabled={
                                        !this.state.prizesFormIsValid ||
                                        !isSettingsFormValid ||
                                        !isBaseFormValid ||
                                        !isGameSpecificSettingsFormValid
                                    }
                                    onClick={this.submitPresetForm}
                                >
                                    {this.isNotes ? `Edit` : `Create`}
                                </button>
                            </div>
                        )}
                    </div>
                </div>
                <Dialog
                    open={this.state.cancelDialog}
                    onConfirm={this.cancelConfig}
                    onClose={this.closeCancelDialog}
                    addedClassName={"config-cancel-dialog"}
                    confirmLabel={"Yes, cancel my configuration"}
                    cancelLabel={"No, i've changed my mind"}
                >
                    <img
                        src="/images/attention.png"
                        width="268"
                        height="230"
                    />
                    <h2>
                        Are you sure you want to cancel the configuration in
                        progress?
                    </h2>
                    <p>
                        Once you cancel this configuration, all changes and
                        settings made so far will be erased.
                    </p>
                </Dialog>
                {this.props.submittingPresetState && (
                    <Dialog
                        open={
                            this.props.submittingPresetState.error ==
                            false &&
                            this.props.submittingPresetState.success == true
                        }
                        onClose={() => {
                            this.props.clearSubmitPreset();
                        }}
                        onConfirm={() => {
                            this.props.clearPreset();
                            this.cancelConfig();
                        }}
                        addedClassName={"presets-success-dialog"}
                        confirmLabel={"Go to presets list"}
                        cancelLabel={"Review preset form"}
                    >
                        <img
                            src="/images/hurray.png"
                            width="268"
                            height="230"
                        />
                        <h2>Your preset is created!</h2>
                        <p>
                            Congratulations, your preset has been
                            successfully created. Thank you for your time!
                        </p>
                    </Dialog>
                )}
            </div>
        );
    }
}

const mapStateToProps = state => ({
    subsidiariesList: presetsStoreSelectors.subsidiariesList(state),
    subsidiariesLoading: presetsStoreSelectors.subsidiariesLoading(state),
    editingPreset: presetsStoreSelectors.editingPreset(state),
    submitPresetLoading: presetsStoreSelectors.submitPresetLoading(state),
    submittingPresetState: presetsStoreSelectors.submittingPresetState(state),
    presetLoading: presetsStoreSelectors.presetLoading(state),
    initialPreset: presetsStoreSelectors.initialPreset(state),
    initialPresetPrizes: presetsStoreSelectors.initialPresetPrizes(state),
    initialGameSpecificSettings: presetsStoreSelectors.initialGameSpecificSettings(state),
    denominations: presetsStoreSelectors.denominations(state),
    denominationsLoading: presetsStoreSelectors.denominationsLoading(state),
    gameBundles: presetsStoreSelectors.gameBundles(state),
    gameBundlesLoading: presetsStoreSelectors.gameBundlesLoading(state),
    gamesList: presetsStoreSelectors.games(state),
    gamesLoading: presetsStoreSelectors.gamesLoading(state),
});

const mapDispatchToProps = {
    getSubsidiaries: PresetsActionCreators.getSubsidiaries,
    updateEditingPreset: PresetsActionCreators.updateEditingPreset,
    addPreset: PresetsActionCreators.addPreset,
    clearPreset: PresetsActionCreators.clearPreset,
    getPreset: PresetsActionCreators.getPreset,
    editPreset: PresetsActionCreators.editPreset,
    getDenominations: PresetsActionCreators.getDenominations,
    clearSubmitPreset: PresetsActionCreators.clearSubmitPreset,
    getGameBundles: PresetsActionCreators.getGameBundles,
    getGames: PresetsActionCreators.getGames
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withRouter(PresetConfiguration));
